import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { FileText, Scale } from "lucide-react";

export type ViewMode = "drafter" | "attorney";

interface ViewModeToggleProps {
  mode: ViewMode;
  onChange: (mode: ViewMode) => void;
}

export function ViewModeToggle({ mode, onChange }: ViewModeToggleProps) {
  return (
    <TooltipProvider>
      <div className="flex items-center gap-2">
        <span className="text-xs text-muted-foreground font-medium">View:</span>
        <ToggleGroup
          type="single"
          value={mode}
          onValueChange={(v) => { if (v) onChange(v as ViewMode); }}
          className="border rounded-md p-0.5 bg-muted/40"
        >
          <Tooltip>
            <TooltipTrigger asChild>
              <ToggleGroupItem
                value="drafter"
                aria-label="Drafter mode"
                className="h-7 px-2.5 text-xs gap-1.5 data-[state=on]:bg-background data-[state=on]:shadow-sm"
              >
                <FileText className="h-3.5 w-3.5" />
                Drafter
              </ToggleGroupItem>
            </TooltipTrigger>
            <TooltipContent>
              <p className="text-xs max-w-[200px]">Structured view with plain-language summaries. Ideal for Finance and HR.</p>
            </TooltipContent>
          </Tooltip>
          <Tooltip>
            <TooltipTrigger asChild>
              <ToggleGroupItem
                value="attorney"
                aria-label="Attorney mode"
                className="h-7 px-2.5 text-xs gap-1.5 data-[state=on]:bg-background data-[state=on]:shadow-sm"
              >
                <Scale className="h-3.5 w-3.5" />
                Attorney
              </ToggleGroupItem>
            </TooltipTrigger>
            <TooltipContent>
              <p className="text-xs max-w-[200px]">Full prose view with inline editing, locking, and redline comparison. Ideal for Legal.</p>
            </TooltipContent>
          </Tooltip>
        </ToggleGroup>
      </div>
    </TooltipProvider>
  );
}
